import app from 'flarum/forum/app';

let loading = false;
let hasLoaded = false;
let onLoadedCallbacks = [];

export default function loadKnowledgeBaseTags(onLoadedCallback) {
  // Tags have already been loaded
  if (hasLoaded) {
    onLoadedCallback();
    return;
  }

  // Load knowledgeBaseTags if not already loading
  if (!loading) {
    loading = true;

    // Load knowledgeBaseTags
    app.store
      .find('support/tags', {
        filter: {
          inknowledgebase: true,
        },
        include: 'children,parent',
      })
      .then(() => {
        hasLoaded = true;
        loading = false;

        onLoadedCallback();

        // Give callback
        onLoadedCallbacks.map((cb) => cb());

        m.redraw();
      });
  } else {
    onLoadedCallbacks.push(onLoadedCallback);
  }
}
